export default "__VITE_ASSET__5c0bd059__"